import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PublishState {
  latestVersion: string | null;
}

const initialState: PublishState = {
  latestVersion: null,
};

const publishSlice = createSlice({
  name: "publish",
  initialState,
  reducers: {
    setLatestVersion: (state, action: PayloadAction<string>) => {
      state.latestVersion = action.payload;
    },
  },
});

export const { setLatestVersion } = publishSlice.actions;
export default publishSlice.reducer;
